import { Pagination } from '@arco-design/web-react';
import './index.less'
export default function RedqueenPagination(props) {
  return (
    <Pagination className={"paginationCustomization"} sizeOptions={[5, 10, 20, 50, 100, 200]} showTotal showJumper sizeCanChange {...props} />
  );
}